import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Input from "../../../../components/common/inputs/Input";
import Button from "../../../../components/common/button/Button";
import Table from "../../../../components/common/table/Table";
import { questionsColumns } from "../../../../constant/tables-columns/tablesColums";
import { questionValidation } from "../../../../utils/validation/course/questionValidation";
import { warningMessage } from "../../../../utils/toastify-message/ToastifyMessage";
import TextArea from "../../../../components/common/inputs/TextArea";

const { forwardRef, useRef, useImperativeHandle } = React;

const CourseQuestions = forwardRef(({ questionData, handleQuestions }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {
      setQuestions([]);
      setQuestion(null);
    },
  }));

  console.log(questionData);

  const [question, setQuestion] = useState(null);
  const [questions, setQuestions] = useState([]);

  const formHandler = async (values, { resetForm }) => {
    let isExist = questions.filter((item) => {
      return item.title == values.title;
    });
    if (!isExist.length) {
      setQuestions((prev) => [...prev, values]);
      setQuestion(null);
      resetForm();
    } else {
      warningMessage("این سوال از قبل موجود است.");
    }
  };

  const onDelete = (data) => {
    const newquestions = questions.filter((item) => item.title != data.title);
    setQuestions(newquestions);
  };

  const handleNewQuestions = () => {
    handleQuestions(questions);
    setShowModal(false);
  };

  useEffect(() => {
    if (questionData?.length) {
      setQuestions(questionData);
    }
  }, [questionData]);

  return (
    <>
      <div
        className={`admin-edit-backdrop fixed top-0 right-0 w-full h-full transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        hidden={!showModal}
        role="dialog"
        aria-label="پرسش‌های دوره"
        aria-modal="true"
        className={`admin-edit-drawer w-full h-full overflow-y-scroll  bg-white shadow-md z-40 rounded-3xl p-4 transition-all absolute top-0 -left-[120%] ${
          showModal && "!left-0 is-open"
        }`}
      >
        <div className="flex w-full items-center justify-between">
          <h4>اضافه کردن ویژگی</h4>
          <Button
            onClick={handleNewQuestions}
            type="button"
            color="primary"
            text="بازگشت"
          />
        </div>
        <Formik
          enableReinitialize
          initialValues={{
            title: question?.title || "",
            description: question?.description || "",
          }}
          validationSchema={questionValidation}
          onSubmit={formHandler}
        >
          {() => (
            <Form>
              <div className="grid gap-6 my-4 md:grid-cols-2">
                <Input
                  name={"title"}
                  placeholder="عنوان"
                  label="عنوان"
                  type="text"
                />
                <TextArea
                  name={"description"}
                  placeholder="توضیحات"
                  label="توضیحات"
                  type="text"
                />
              </div>
              <div className="mt-2 flex flex-wrap gap-3">
                {question && (
                  <Button
                    type="button"
                    onClick={() => setQuestion(null)}
                    text={"بازگشت"}
                    color={"danger"}
                  />
                )}
                <Button text={question ? "ویرایش" : "افزون"} color={"primary"} />
              </div>
            </Form>
          )}
        </Formik>

        <Table
          columns={questionsColumns}
          rows={questions}
          onDelete={onDelete}
          notFoundMessage="شما هنوز هیچ ویژگی اضافه نکرده اید"
        />
      </div>
    </>
  );
});
export default CourseQuestions;
